import type { CSSProperties, JSX, MouseEventHandler, RefObject } from 'react'
import type {
  FallbackImageSizes,
  IFallbackImageProps,
} from 'atoms/FallbackImage'
import type { IconNames, IconSizes } from 'atoms/Icon'
import type { OverlayLayoutColors } from 'atoms/OverlayLayout'
import type { TextBoxTypes } from 'atoms/TextBox'
import type { COLOR } from 'vars/index'
import type { CardAnimations, CardCorners, CardPosterSize } from './Card.h'

import { AnimatedCard, BaseCard } from './base-card'

export interface ICard {
  corners?: CardCorners
  posterUrl?: string | null | undefined
  videoPosterUrl?: string | null | undefined
  posterHeight?: CardPosterSize
  posterWidth?: CardPosterSize
  posterEnabled?: boolean
  playVideo?: boolean
  className?: string
  overlayOnHoverEnabled?: boolean
  childrenTransition?: CardAnimations
  aspectRatio?: number
  children?: JSX.Element | undefined
  gradient?: COLOR | undefined
  backgroundColor?: COLOR
  backgroundColorHovered?: COLOR
  overlayEnabled?: boolean
  overlayHeight?: string
  overlayVerticalColor?: OverlayLayoutColors
  width?: string
  height?: string
  scaleCoef?: number
  transitionName?: CardAnimations | CardAnimations[]
  transitionTrigger?: boolean
  duration?: number
  cardRef?: RefObject<HTMLDivElement | null>
  style?: CSSProperties
  onClick?: any
  onMouseEnter?: MouseEventHandler<HTMLDivElement>
  onMouseLeave?: MouseEventHandler<HTMLDivElement>
  purchaseTitle?: string
  lazyImage?: boolean
  rented?: boolean
  transformScale?: number
  paid?: boolean

  overlayGradient?: OverlayLayoutColors
  hidePriceOnHover?: boolean
  gridCard?: boolean
  selected?: boolean
  borderVisible?: boolean
  backgroundColorForLogo?: COLOR
  viewedButtonFavorite?: boolean
  backgroundCover?: React.ReactNode
  posterContent?: React.ReactNode
  lockedIcon?: IconNames
  ageRatingLabel?: string
  isAgeRating?: boolean

  fallbackImageSize?: FallbackImageSizes
  fallbackImageBackground?: IFallbackImageProps['background']
  fallbackImageColor?: IFallbackImageProps['color']
  roundedPoster?: boolean
  locked?: boolean
  lockedColor?: COLOR
  lockedTitle?: string
  lockedFont?: TextBoxTypes
  lockedSizeIcon?: IconSizes
  handlePosterLoading?: () => void
  handlePosterError?: () => void
  verticalVideo?: boolean
  dataTestId?: string
  scaleOnHover?: boolean
  isExternalContent?: boolean
  aclBlockedBy?: boolean
  /**
   * FP-4260: render the card as a content details page recommendation (Figma
   * `16284:249978`) — square corners and a purchase label pinned to its 1240
   * metrics. Opt-in, so every other card keeps the shared ladder.
   */
  detailsCard?: boolean
  /** Already-translated "new content" badge text (WBS `labels`, bottom-right). */
  newLabel?: string
  /** Already-translated short "new content" badge text (Channels, top-right). */
  newLabelShort?: string
}

export const Card = (props: ICard): JSX.Element => {
  return props.transitionName ? (
    <AnimatedCard transitionName={props.transitionName} {...props} />
  ) : (
    <BaseCard {...props} />
  )
}
